module.exports = "<div class=\"overlays-status\" *ngIf=\"statusMessage && !loading\" [@timeline-status]>\r\n\t<div class=\"text-container\">\r\n\t\t<span>{{statusMessage}}</span>\r\n\t\t<button class=\"close\" (click)=\"close()\">X</button>\r\n\t</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/overlays/components/overlay-status/overlay-status.component.html
// module id = ../../../../../src/app/packages/overlays/components/overlay-status/overlay-status.component.html
// module chunks = main